import { render, staticRenderFns } from "./relay_status.vue?vue&type=template&id=7537015f&scoped=true"
import script from "./relay_status.vue?vue&type=script&lang=js"
export * from "./relay_status.vue?vue&type=script&lang=js"
import style0 from "./relay_status.vue?vue&type=style&index=0&id=7537015f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537015f",
  null
  
)

export default component.exports